<template>
  <ion-header>
    <ion-toolbar :color="color" class="toolbar-header">
      <div slot="start" class="header-icon">
        <img :src="$asset('/images/e-gro_green.svg')" />
      </div>
      <ion-segment :value="current" class="header-menu-segment">
        <ion-segment-button value="dashboard" @click="$goto('dashboard')">
          <ion-label>{{ $t('header.Dashboard') }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="conditions" @click="$goto('conditions.index')">
          <ion-label>{{ $t('header.Conditions') }}</ion-label>
        </ion-segment-button>
      </ion-segment>
      <ion-buttons slot="end">
        <ion-button class="facility-name" disabled>
          <p>{{ facilityName }}</p>
          <ion-icon />
        </ion-button>
        <ion-menu-toggle menu="alert-list">
          <ion-button>
            <ion-icon name="notifications" />
          </ion-button>
        </ion-menu-toggle>
        <ExportButton v-if="$can('exportData', 'bridge')" />
        <ion-button class="ion-padding-left" @click="logout">
          <ion-icon name="log-out" />
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
    <slot />
  </ion-header>
</template>

<script>
import { bridgeQueries, BridgeRepository } from '~gro-modules/Bridge'
import ExportButton from './ExportButton'

export default {
  components: { ExportButton },
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
  },
  setup () {
    const { facilityName } = bridgeQueries.getCurrent('facilityName')
    return {
      facilityName,
    }
  },
  computed: {
    current () {
      const namePart = this.$route.name.split('.')
      return namePart[0]
    },
  },
  methods: {
    async logout () {
      if (!(await this.$confirm('auth.logout.Confirm'))) {
        return
      }
      try {
        await this.$bridge.logout()
      } finally {
        await this.$storage.forget('conditionsView')
        await BridgeRepository.clear()
        location.href = '/'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.header-icon {
  padding: 5px;
}

.sc-ion-segment-md-s > .segment-button-checked {
  color: var(--ion-color-primary-contrast);
  --btn-border-color: var(--ion-color-primary-tint);
  --border-width: 0 0 3px 0;
}

.sc-ion-segment-md-s > ion-segment-button {
  color: var(--ion-color-primary-contrast);
}

ion-segment {
  width: 300px;
  padding-left: 25px;
}

ion-segment-button {
  --color-checked: var(--ion-color-primary-contrast);
  --color: var(--ion-color-primary-tint);
  --background-hover: transparent;
  --indicator-color: var(--ion-color-cto);
  --indicator-height: 4px;
  font-size: 0.875rem;
  letter-spacing: 0.6px;
  font-weight: bold;
  text-transform: uppercase;
  width: 125px;
}

.facility-name {
  font-size: 0.751645rem;
  text-transform: unset;
  opacity: 1;

  ion-icon {
    opacity: 1;
    color: transparent;
    background: url('/images/icons/facility.svg') no-repeat center;
    margin-left: 10px;
  }
}

ion-toolbar {
  padding-left: 10px;
  padding-right: 10px;
  height: 65px;
  display: flex;
  align-content: center;
}
</style>
